<h5 i18n="Table title" class="heading text-uppercase font-weight-bold" i18n="Table associated to reservation">Table</h5>
<div class="text-muted" [ngSwitch]="showTableAs">
    <ng-container *ngSwitchCase="'linked'" i18n>You have linked your booking to a table with {{ table.people_nb }} participants.</ng-container>
    <ng-container *ngSwitchCase="'joined'" i18n>You have joined a table with {{ table.people_nb + nbSelectedParticipants }} participants in total.</ng-container>
</div>
<div class="text-muted" i18n>
    Table join code:
    <pre class="d-inline">{{ table.joining_code }}</pre>
</div>
